import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { MechanicService } from '../../../business-services/mechanic.service';
import { RolesRightsService } from '../../../business-services/roles-rights.service';
import * as fromEnums from './../../../../../../Autofacets-Core/src/app/utils/enums';
import * as Enums from "projects/Autofacets-Core/src/app/utils/enums";
import { Features } from '../../../business-entities/user-role-view-model';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';

@Component({
  selector: 'app-add-mechanic',
  templateUrl: './add-mechanic.component.html'
})
export class AddMechanicComponent implements OnInit {

  addmechanicForm: FormGroup;
  dealer: string = '';
  dealerList: any[];
  selectedDealerId: string = '';
  searchString = '';
  employeeList:any[]=[]
  isSearched:boolean = false;
  addMechanic:boolean=false;
  isAddedAsMechanic:boolean=false;
  employeeId:number;
  closeResult: string;
  EmployeeListRequestModel={
    startRecordNumber: 0,
    PageSize: 25,
    searchString: '',
    isFromMechanicScreen: true,
  }
  throttle = 100;
  scrollDistance = 1;
  totalCount: number = 0;
  isTeamLead:boolean=false;
  isDmsMechanicIdUsed = false;
  featureList: Features[] = [];
  isCustomerWaitingSlotsEnabled:boolean = false;

  constructor(public service: MechanicService,
    private router: Router, private spinner: NgxSpinnerService,
    private toaster: ToastrService,
    private translate: TranslateService,
    private formBuilder: FormBuilder,
    private userService: UserDataService,private activeModal : NgbActiveModal,
    private rolesRightsService: RolesRightsService,
    private modalService: NgbModal,
    private secureStorage: SecureStorage) { }

  ngOnInit(): void {
    this.isDmsMechanicIdUsed = localStorage.getItem('Theme') === 'mg';
    this.isTeamLead=false;
    this.dealerList = this.service.dealerList;
    this.addmechanicForm = this.formBuilder.group({
      name: [{value: null, disabled: true}, [Validators.required]],
      employeeNo: [{value: null, disabled: !this.isDmsMechanicIdUsed}, [Validators.required]],
      dmsMechanicNo: [{value: null, disabled: !this.isDmsMechanicIdUsed}, [Validators.required]],
      // emailId: [{value: ''}, [Validators.required]],
      adEmail: [{value: ''}, [Validators.required, Validators.pattern(Enums.RegexKeyCollection.Email)]],
      adUserId: ['', [Validators.required]],
      isActive: [true],
      createdBy: [],
      dealerName: ["", [Validators.required]],
      capacityPlanning:[false],
      isConsiderCustomerWaitingSlots:[true]
    });
    this.featureList = this.secureStorage.getKeyData('feature');
    this.isCustomerWaitingSlotsEnabled = this.featureList.find(x=>x.featureCode == 'CustomerWaitingSlot')?.isActive ?? false;
    if (this.dealerList && this.dealerList.length == 1) {
      this.selectedDealerId = this.userService.currentUserValue.dealerId;
      this.dealer=this.selectedDealerId;
      this.cpf.dealerName.disable();
  }
  this.SearchEmployee();
  }
  get cpf() {
    return this.addmechanicForm.controls;
  }

  async onDealerSelected(dealerId: string) {
    this.selectedDealerId = dealerId;
  }

  SearchEmployee(isFromSearch=false){
     this.addMechanic = false;
     this.isAddedAsMechanic=false;
     this.searchString = this.searchString.trim();
     this.isSearched = true;
       if(isFromSearch)
        {
          this.employeeList = [];
          this.EmployeeListRequestModel.startRecordNumber=0;
        }

      this.spinner.show();
      this.EmployeeListRequestModel.searchString=this.searchString;
      this.rolesRightsService.getEmployeeList(this.EmployeeListRequestModel).then((res) =>{
        this.totalCount = 0;
        if(res?.responseObject && res?.responseObject.length > 0){
          this.employeeList.push(...this.employeeDataMapper(res?.responseObject))
          this.totalCount = this.employeeList? this.employeeList[0].totalCount:0;
        }
        this.spinner.hide();
      })

  }

  private employeeDataMapper(employee) {
    return employee.map((emp, i) => {
      return {
         row: i + 1,
         id:emp.id,
         firstName:emp.firstName,
         lastName:emp.lastName,
         email:emp.email,
         phoneNo:emp.phoneNo,
         phoneCode:emp.phoneCode,
         isAddedAsUser:emp.isAddedAsUser,
         adEmail:emp.adEmail,
         groupRoleName:emp.groupRoleName,
         functionCode:emp.functionCode,
         functionCodeDescription:emp.functionCodeDescription ,
         locationCode:emp.locationCode ,
         locationName:emp.locationName ,
         employeeNo:emp.employeeNo ,
         dmsMechanicNo:emp.dmsMechanicNo ,
         isTeamLead:emp.isTeamLead,
         totalCount:emp.totalCount ,
         adGuid :emp.adGuid
      }
    });
  }

  ClearEmployee(){
    this.employeeList=[];
    this.searchString = ''
    this.SearchEmployee();
  }

  onScrollDown(_ev) {
    if(this.totalCount > this.employeeList.length){
      this.EmployeeListRequestModel.startRecordNumber = this.employeeList.length
      this.SearchEmployee();
    }
  }

  OpenAddMechanicForm(content:any,user:any){
    this.addmechanicForm.controls['name'].setValue(null);
    this.addmechanicForm.controls['employeeNo'].setValue(null);
    this.addmechanicForm.controls['dmsMechanicNo'].setValue(null);
    this.addmechanicForm.controls['adEmail'].setValue('');
    this.addmechanicForm.controls['adUserId'].setValue('');
    this.addmechanicForm.controls['isActive'].setValue(true);
    this.addmechanicForm.controls['dealerName'].setValue('');
    this.addmechanicForm.controls['capacityPlanning'].setValue(false);
    this.addmechanicForm.controls['adUserId'].setValue(user.adGuid);
    this.dealer='';

    this.employeeId = user.id;
    this.addMechanic = true;
    this.isAddedAsMechanic=user.isAddedAsUser;
    this.addmechanicForm.patchValue({
      name: (user.firstName + ' '+ user.lastName),
      // emailId: user.email,
      adEmail:user.email,
      employeeNo:user.employeeNo
    })
    let dealerId= this.dealerList.filter(x=>x.locationCode === user.locationCode)[0]?.value;
    if(dealerId)
    {
      this.selectedDealerId=dealerId;
      this.dealer=dealerId;
      this.addmechanicForm.patchValue({
        dealerName:dealerId
      })
    }


    this.isTeamLead=user.isTeamLead;
    //if mechanic is team than this mechanic can not be include in capacity planning
    if(user.isTeamLead)
    {
      this.addmechanicForm.controls['capacityPlanning'].disable();
    }
    else
    {
      this.addmechanicForm.controls['capacityPlanning'].enable();
    }
    this.modalService.open(content, {size: 'lg', ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  async AddMechanic() {
    let successMessage = this.translate.instant("lblMechanicAddedSuccessfully");
    let errorMessage = this.translate.instant("lblErrorMessage");
    let WarningMessage = this.translate.instant("lblErrorWarningForValue");
    let userLimitError = this.translate.instant('lblMichanicCreationLimitExceed');
    let mechanicEmailExist = this.translate.instant('lblMechanicEmailExists');
    let duplicateDmsMechanicId = this.translate.instant('lblDuplicateDmsMechanicId');
    let currentUser = this.userService.currentUserValue.id;
    let mechanicInfo =
    {
      name: this.addmechanicForm.get('name').value,
      employeeNo: this.addmechanicForm.get('employeeNo').value,
      dmsMechanicNo: this.addmechanicForm.get('dmsMechanicNo').value,
      // emailId: this.addmechanicForm.get('adEmail').value,
      adUserId: this.addmechanicForm.get('adUserId').value,
      isActive: this.addmechanicForm.get('isActive').value,
      createdBy: currentUser,
      dealerId: this.selectedDealerId.toString(),
      adEmail : this.addmechanicForm.get('adEmail').value,
      employeeId: this.employeeId ,
      isCapacityPlanning:this.addmechanicForm.get('capacityPlanning').value,
      isConsiderCustomerWaitingSlots:this.addmechanicForm.get('isConsiderCustomerWaitingSlots').value,
      isTeamLead:this.isTeamLead
    }
    
    let isMechanicValid = true;
    // used to validate duplicate mechanic id for MG tenant
    if (this.isDmsMechanicIdUsed) {
      this.spinner.show();
      // validate dms id
      await this.service.ValidateDmsMechanicId(0, mechanicInfo.dmsMechanicNo).then(res => {
        this.spinner.hide();
        isMechanicValid = res;
        if (!isMechanicValid) {
          this.toaster.error(duplicateDmsMechanicId);
        }
      }, error => {
        isMechanicValid = false;
        this.spinner.hide();
        if (error.status === Constant.BadRequest) {
          this.toaster.warning(WarningMessage);
        }
        else {
          this.toaster.error(errorMessage);
        }
      }).finally(() => {
        this.spinner.hide();
      });
    }
    if (isMechanicValid) {
      this.spinner.show();
      this.service.AddMechanic(mechanicInfo).then(res => {
          this.spinner.hide();
          let result = res.responseObject;
          if (result.errorCount && result.errorCount > 0) {
            let errorResponse = result.result;
  
          if(errorResponse.errorCode === fromEnums.ErrorCodes.UserCreationLimitExceed){
            this.toaster.error(userLimitError);
          }
          if(errorResponse.errorCode === fromEnums.ErrorCodes.MechanicEmailExistsCode){
            this.toaster.error(mechanicEmailExist + ' ' + errorResponse.errorMessage);
          }
        }
        else if(res.responseObject === Constant.ValidationFailure && res.responseCode === Constant.SuccessResponseCode){
          //GUID already exists
          let errormsg = this.translate.instant("lblAdGUIDAlreadyExists");
          this.toaster.error(errormsg);
        }
        else if(res.responseObject === Constant.MechanicAdEmailAlreadyExists && res.responseCode === Constant.SuccessResponseCode){
          //AdEmail Id already exists
          let errormsg = this.translate.instant("lblAdEmailAlreadyExists");
          this.toaster.error(errormsg);
        }
        else if (res.responseCode === Constant.SuccessResponseCode) {
          localStorage.setItem('lastMechanic', JSON.stringify(mechanicInfo));
          document.getElementById("modelButton").click();
          this.activeModal.close({ success: true });
          this.toaster.success(successMessage);
        }
        else if (res.responseCode === Constant.InternalError) {
          let errormsg = this.translate.instant("lblInternalError");
          this.toaster.error(errormsg);
        }
        else if (res.responseCode === Constant.ResponseCode) {
          let errormsg = this.translate.instant("lblAlreadyAdded");
          this.toaster.warning(errormsg);
        }
      }, error => {
        this.spinner.hide();
        if (error.status === Constant.BadRequest) {
          this.toaster.warning(WarningMessage);
        }
        else {
          this.toaster.error(errorMessage);
        }
  
      }).finally(() => {
        this.spinner.hide();
      });
    }
  }
  OnClose(){
    this.activeModal.close({ success: true });
  }

}
